import { Product, ProductType } from '@inter-ikea-storageone/range';

const INTERIORS_TYPE_SORTING_ORDER = [
  ProductType.BOAXEL_SHELF,
  ProductType.BOAXEL_ADJ_SHELF,
  ProductType.BOAXEL_METAL_SHELF,
  ProductType.BOAXEL_WIRE_SHELF,
  ProductType.BOAXEL_CLOTHES_RAIL,
  ProductType.BOAXEL_MESH_BASKET,
  ProductType.BOAXEL_DRYING_RACK,
  ProductType.BOAXEL_SHOE_SHELF
];

const getSortingOrderOfProduct = (product: Product) =>
  INTERIORS_TYPE_SORTING_ORDER.indexOf(product.type);

export const sortInteriorClustersByPreferredTypeOrder = (clusters: Product[][]) =>
  [...clusters].sort(
    (clusterA, clusterB) =>
      getSortingOrderOfProduct(clusterA[0]) - getSortingOrderOfProduct(clusterB[0])
  );
